import { render, staticRenderFns } from "./OfficialLeagueRank.vue?vue&type=template&id=6dda74e4&"
import script from "./OfficialLeagueRank.vue?vue&type=script&lang=js&"
export * from "./OfficialLeagueRank.vue?vue&type=script&lang=js&"
import style0 from "./OfficialLeagueRank.vue?vue&type=style&index=0&id=6dda74e4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports